import { Component, Input, OnInit } from '@angular/core';
import { ThemingService } from '@shared/services/theming.service';
import { Theme } from '@shared/themes/default.theme';

@Component({
  selector: 'contact-box',
  templateUrl: './contact-box.component.html',
  styleUrls: ['./contact-box.component.scss'],
  standalone: false,
})
export class ContactBoxComponent implements OnInit {
  @Input() overrideTheme: Theme;

  @Input() phoneType: string = 'phone';

  @Input() producerId: string | number;

  theme: Theme;
  phone: string;

  private readonly hiddenContactProducerIds = new Set<string>([
    // 'P43274',
    // 'P43580',
    // 'P44681',
    // 'P18089',
    'P46330',
    'P9576',
    'P45063',
  ]);

  constructor(private themeService: ThemingService) {
    this.themeService.themeChange.subscribe((theme: Theme) => {
      this.theme = theme;
      this.setPhone();
    });
  }

  ngOnInit(): void {
    // this.theme = this.themeService.theme;

    if (this.overrideTheme) {
      this.theme = this.overrideTheme; //optionally override theme for just one instance
    }

    this.setPhone();
  }

  get hideContactInfo(): boolean {
    const normalizedProducerId = this.normalizeProducerId(this.producerId);

    return normalizedProducerId ? this.hiddenContactProducerIds.has(normalizedProducerId) : false;
  }

  private normalizeProducerId(producerId: string | number): string {
    if (producerId === undefined || producerId === null) {
      return '';
    }

    const normalizedProducerId = `${producerId}`.trim();

    if (!normalizedProducerId) {
      return '';
    }

    if (normalizedProducerId === 'generic' || normalizedProducerId === 'auto') {
      return normalizedProducerId;
    }

    return /^P/.test(normalizedProducerId) ? normalizedProducerId : `P${normalizedProducerId}`;
  }

  setPhone() {
    if (this.phoneType && this.theme && this.theme.agent[this.phoneType]) {
      // console.log('setting from setPhone', this.theme);
      this.phone = this.theme.agent[this.phoneType];
    } else {
      this.phone = this.theme?.agent?.phone;
    }
  }
}
